export const environment = {
  rememberMeKey: 'HB_RM_K_D',
  base_url: 'https://api.haverbridge.com/api/v1',
  verificationTimer: 'verificationTimer',
  image_url: 'https://api.haverbridge.com/api/v1/upload/uploadFile',
  storageKey: 'HB_ST_K_D',
  socket_url: 'https://api.haverbridge.com/',
  googleKey: 'AIzaSyCES0pCZNW9kCYzWiq4g0oDvSjPQUAyLVY', // Google key of  for localhost and staging
  // stripePublicKey:
  //   'pk_test_51Qpp54E9dCHbiXJV6Okor1RpLgwCLKDTvIIOq7SFdVfU7Q1UyuoVFactBrmrdqCe1ZYcx4gh53KIZjJDh4522teq00jWleYgRa',
  // googleClientId:
  //   '181364161362-7aagrumddf0t6185cnicv9vu5u39ogoe.apps.googleusercontent.com',
  // facebookAppId: '',
  langKey: 'lang',
  videoDetails: 'videoDetails',
  STRIPE_PUBLISH_KEY: 'pk_test_51N6udzCGmEvY1i4qvCYGi6yVAanogWp7OdFFRiieiw7FyLU57r9PnFRO6oHCKJYOEYNvU599x7Kzq7kfT1RV1clI00UfYpub4W'

  // firebaseConfig: {
  //   apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
  //   authDomain: 'prepbase-76b91.firebaseapp.com',
  //   projectId: 'prepbase-76b91',
  //   storageBucket: 'prepbase-76b91.firebasestorage.app',
  //   messagingSenderId: '181364161362',
  //   appId: '1:181364161362:web:55962752a843c55a81d88b',
  //   measurementId: 'G-GTENSLC3WN',
  //   vapidKey: 'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  // }
};
